/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The EncountersidEncounterNotesAttributes model module.
 * @module model/EncountersidEncounterNotesAttributes
 * @version v0.3
 */
export default class EncountersidEncounterNotesAttributes {
  /**
   * Constructs a new <code>EncountersidEncounterNotesAttributes</code>.
   * @alias module:model/EncountersidEncounterNotesAttributes
   * @class
   * @param text {String} 
   */
  constructor(text) {
    this.text = text;
  }

  /**
   * Constructs a <code>EncountersidEncounterNotesAttributes</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EncountersidEncounterNotesAttributes} obj Optional instance to populate.
   * @return {module:model/EncountersidEncounterNotesAttributes} The populated <code>EncountersidEncounterNotesAttributes</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EncountersidEncounterNotesAttributes();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('text'))
        obj.text = ApiClient.convertToType(data['text'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
EncountersidEncounterNotesAttributes.prototype.id = undefined;

/**
 * @member {String} text
 */
EncountersidEncounterNotesAttributes.prototype.text = undefined;

